import React from 'react'
import Page500 from '../pages/500'
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Any action to register the error
    }

    render() {
        if (this.state.hasError) {
            return (
                <Page500 />
            )
        }
        return this.props.children;
    }
}